import { Components, Theme } from '@mui/material/styles';

export const graphTheme: Components<Theme>['MuiPaper'] = {
  // styleOverrides: {},
  // variants: [],
};
